import Vue from './vue';
import router from '../main/vue-routes';
import components from '../algolia';
import {getSpecSheetPath} from '../main/utils';

const loadSpecSearch = () => {
  if (document.querySelector('.spec-search')) {
    new Vue({
      el: '.spec-search',
      comments: true,
      components,
      router,
      data() {
        return {
          indexName: this.$algolia.indexPrefix + 'product_variations',
          langcode: this.$route.params.langcode || 'en',
          filterString: null
        };
      },
      methods: {
        onVisibilityChange(isVisible, entry) {
          if (isVisible) entry.target.click();
        },
        getSpecSheetLink(sku) {
          return getSpecSheetPath(sku, this.$route.params.langcode);
        },
        handleClick(item, sendEvent) {
          sendEvent('click', item, 'Spec Finder Result Clicked');

          window.ga('send', 'event', {
            eventCategory: 'sheet',
            eventAction: 'download',
            eventLabel: 'spec sheet'
          });
        }
      }
    });
  }
};

export default loadSpecSearch;
